import { useMsal } from "@azure/msal-react";
import { useTranslation } from "react-i18next";

const LogOut = () => {
    const { instance } = useMsal();
    const { t } = useTranslation();
    return (
        <div style={{ textAlign: 'center' }}>
            <span onClick={() => { instance.logoutRedirect(); }} id="logout" className="ds-text-primary ds-font-medium ds-cursor-pointer" style={{ fontSize: '15px' }}>
                {t("LogOut")}
            </span>
        </div>
    )
}
export default LogOut;